import { styled } from '@mui/system';
import { Box, Card, Typography } from '@mui/material';
import { colors, fontFamilies } from '../../../../../constants/theme';
import {
  SectionHeading as BaseSectionHeading,
  DescriptionText as BaseDescriptionText,
} from '../../../../../ui/typography';
export const SectionWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  maxWidth: 1200,
  width: '100%',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}));

export const SectionHeading = styled(BaseSectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  textAlign: 'center',
  marginBottom: 16,
}));

export const SectionSubtext = styled(BaseDescriptionText)(({ theme }) => ({
  ...theme.typography.subtext,
  textAlign: 'center',
  marginBottom: 24,
}));

export const BioCard = styled(Card)(({ theme }) => ({
  backgroundColor: colors.whiteText,
  borderRadius: 16,
  padding: 32,
  boxShadow:
    '-4px -4px 17.8px 0px rgba(205, 214, 223, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    padding: 24,
    borderRadius: 12,
  },
  [theme.breakpoints.down('sm')]: {
    padding: 16,
  },
}));

export const BioText = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontSize: 18,
  lineHeight: 1.8,
  color: colors.textLight,
  whiteSpace: 'pre-line',
  [theme.breakpoints.down('md')]: {
    fontSize: 16,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 14,
  },
}));
